<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title"><span class="bold">FLIGHT CRAFT 27</span></h1>
<p class="line">
</p><p class="title1">BOEING B-17</p>
<p class="author"><span class="bold">Ben Skipper</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?6f2c6c65